













































import { OComponentDemo } from '../../app/demo';
import Vue from 'vue';

export default Vue.extend({
  name: 'FormExample',
  data() {
    return {
      data: {
        firstName: 'John',
        lastName: '',
        hobbies: ['ONEWHEEL', 'COMPUTERS'],
        about: '',
        age: null,
        gender: 'MALE',
      },
    };
  },
  methods: {
    onSubmit(): void {
      alert(`The form was submitted with:\n${JSON.stringify(this.data, null, 2)}`);
    },
    onClickCancel(): void {
      this.$router.replace({ name: 'Examples' });
    },
  },
  components: { OComponentDemo },
});
